/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The status of a particular dispute.
 *
 * @remarks
 *
 * Read our [disputes guide](https://docs.moov.io/guides/money-movement/accept-payments/card-acceptance/disputes/#dispute-statuses) to learn what each status means.
 */
export const DisputeStatus = {
  ResponseNeeded: "response-needed",
  Resolved: "resolved",
  UnderReview: "under-review",
  Closed: "closed",
  Accepted: "accepted",
  Expired: "expired",
  Won: "won",
  Lost: "lost",
} as const;
/**
 * The status of a particular dispute.
 *
 * @remarks
 *
 * Read our [disputes guide](https://docs.moov.io/guides/money-movement/accept-payments/card-acceptance/disputes/#dispute-statuses) to learn what each status means.
 */
export type DisputeStatus = ClosedEnum<typeof DisputeStatus>;

/** @internal */
export const DisputeStatus$inboundSchema: z.ZodNativeEnum<
  typeof DisputeStatus
> = z.nativeEnum(DisputeStatus);
/** @internal */
export const DisputeStatus$outboundSchema: z.ZodNativeEnum<
  typeof DisputeStatus
> = DisputeStatus$inboundSchema;
